import WalletButtons from './WalletButtons'
export default WalletButtons